import formIconOptions from "@jumbo/constants/formIconOptions";
import React, { useState } from "react";
import {
  TextField,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import CustomSelect from "@jumbo/Dashboards/Banner/CustomSelect";
import { useSelector, useDispatch } from "react-redux";
import { setFormSettings } from "redux/actions/FormBuilder";

import ImagePicker from "@jumbo/Dashboards/Tests/compnents/ImagePicker";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";
import CheckBox from "@jumbo/Dashboards/Banner/CheckBox";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    color: theme.palette.primary.main,
    marginBottom: "16px",
    fontWeight: "bold",
  },
  formControl: {
    width: "100%",
  },
}));

const GeneralSettings = () => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);
  const { formSettings } = useSelector(({ formBuilder }) => formBuilder);
  const dispatch = useDispatch();

  const {
    formTitle,
    formDesc,
    formType,
    confirmation,
    formSubTitle,
    formIcon,
    formPoster,
    archived,
    active,
    privacyMode,
  } = formSettings;

  return (
    <>
      <Grid item xs={12}>
        <CheckBox
          name={"active"}
          title={"فعال"}
          value={active}
          handleChange={() =>
            dispatch(setFormSettings({ ...formSettings, active: !active }))
          }
        />
      </Grid>
      <Grid item xs={12}>
        <CheckBox
          name={"privacyMode"}
          title={"حالت حریم خصوصی"}
          value={Boolean(privacyMode)}
          handleChange={() =>
            dispatch(
              setFormSettings({
                ...formSettings,
                privacyMode: !privacyMode,
              })
            )
          }
        />
      </Grid>
      <Grid item xs={12} md={7}>
        <Typography className={classes.textFieldLabel}>عنوان</Typography>
        <TextField
          id="titleField"
          label="عنوان"
          variant="outlined"
          className={classes.formControl}
          value={formTitle}
          onChange={(e) =>
            dispatch(
              setFormSettings({ ...formSettings, formTitle: e.target.value })
            )
          }
        />
      </Grid>

      <Grid item xs={12} md={7}>
        <Typography className={classes.textFieldLabel}>زیر‌عنوان</Typography>
        <TextField
          id="subtitleField"
          label="زیر‌عنوان"
          variant="outlined"
          className={classes.formControl}
          value={formSubTitle}
          onChange={(e) =>
            dispatch(
              setFormSettings({ ...formSettings, formSubTitle: e.target.value })
            )
          }
        />
      </Grid>

      <Grid item xs={12} md={7}>
        <Typography className={classes.textFieldLabel}>آیکون فرم</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">
            آیکون فرم
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={formIcon}
            onChange={(e) =>
              dispatch(
                setFormSettings({
                  ...formSettings,
                  formIcon: e.target.value,
                })
              )
            }
            label={"آیکون فرم"}
          >
            {formIconOptions.map(({ value, Icon }) => (
              <MenuItem key={value} value={value}>
                <Icon fontSize="small" style={{ marginBottom: "-5px" }} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Typography className={classes.textFieldLabel}>انتخاب پوستر</Typography>
        <ImagePicker
          cover={formPoster}
          handlePick={() => setOpenFileUploader(true)}
          handleRevome={() =>
            dispatch(setFormSettings({ ...formSettings, formPoster: "" }))
          }
          previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
          placeHolderStyles={{ marginInline: "auto", marginBlock: "20px" }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography className={classes.textFieldLabel}>توضیحات</Typography>
        <CKEditor
          editor={ClassicEditor}
          config={{
            language: "fa",
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "link",
              "bulletedList",
              "numberedList",
              "blockQuote",
            ],
            link: {
              addTargetToExternalLinks: true,
              decorators: [
                {
                  mode: "manual",
                  label: "باز کردن در تب جدید",
                  attributes: {
                    target: "_blank",
                  },
                },
              ],
            },
          }}
          data={formDesc}
          onChange={(_, editor) => {
            const data = editor.getData();
            dispatch(setFormSettings({ ...formSettings, formDesc: data }));
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <CustomSelect
          title={"نوع فرم"}
          value={formType}
          handleChange={(val) =>
            dispatch(setFormSettings({ ...formSettings, formType: val }))
          }
          options={[
            { value: "Signup", text: "ثبت‌نام" },
            { value: "Exam", text: "آزمون" },
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomSelect
          title={"تاییدیه"}
          value={confirmation}
          handleChange={(val) =>
            dispatch(setFormSettings({ ...formSettings, confirmation: val }))
          }
          options={[
            { value: "Message", text: "پیام" },
            { value: "QRCode", text: "QR کد" },
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <CheckBox
          name={"archived"}
          title={"آرشیو"}
          value={archived}
          handleChange={() =>
            dispatch(setFormSettings({ ...formSettings, archived: !archived }))
          }
        />
      </Grid>

      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) =>
          dispatch(setFormSettings({ ...formSettings, formPoster: selected }))
        }
        selectedItem={formPoster}
        imageSelector={true}
      />
    </>
  );
};

export default GeneralSettings;
